import React from "react";
import Skeleton from "../../ui-components/Skeleton/Skeleton";
import { useMemo } from 'react';
import { useMatchesMinWidth } from "../../hooks/useMatchesMinWidth";
import { BREAKPOINTS } from "../../../constants";

const HistorySkeletonWrapper = ({ showAsSwiper }) => {
    const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);
    const SkeletonCard = <div className={`card card--compact ${isDeviceSmallerThanTablet ? 'swiper-slide' : ''}`}>
        <div className='card__image'>
            <Skeleton width={'100%'} height={'100%'} />
        </div>
        <div className='card__inner'>
            <div className='card__inner__top'>
                <div className='card__inner__top__content'>
                    <div className='card__address'>
                        <Skeleton width={108} height={16} classNames='radius-xs' />
                    </div>
                    <div className='card__title'>
                        <Skeleton width={176} height={16} classNames='radius-xs mb-3xs' />
                        <Skeleton width={'100%'} height={16} classNames='radius-xs mb-3xs' />
                        <Skeleton width={'100%'} height={16} classNames='radius-xs mb-3xs' />
                    </div>
                </div>
            </div>
            <div className='d-flex justify-between'>
                <Skeleton width={111} height={16} classNames='radius-xs' />
                <Skeleton width={111} height={16} classNames='radius-xs' />
            </div>
        </div>
    </div>

    if (showAsSwiper) {
        return SkeletonCard;
    }

    return (
        <div className="d-flex flex-column">
            {SkeletonCard}
            {SkeletonCard}
        </div>
    );
}

export default HistorySkeletonWrapper;